import React from "react";

import Project from "./project";

import INFO from "../../data/user";
import { Row, Col } from "antd";
import "./styles/allProjects.css";

const AllProjects = () => {
	return (
		<Row justify={"center"} className="all-projects-container">
			{INFO.projects.map((project, index) => (
				<Col
					xs={18}
					sm={24}
					md={24}
					lg={8}
					xl={11}
					className="all-projects-project"
					key={index}
				>
					<Project
						logo={project.logo}
						logo2={project.logo2}
						logo3={project.logo3}
						title={project.title}
						logoArray={project.logoArray}
						description={project.description}
						linkText={project.linkText}
						link={project.link}
						imageData={project.imageData}
					/>
				</Col>
			))}
		</Row>
	);
};

export default AllProjects;
